@if (groups()?.length === 0) {
  <div class="centered">
    <p>Keine Daten</p>
  </div>
} @else if (groups().length > 0) {
  @for (group of groups(); let groupdIdx = $index; track groupdIdx) {
    @if (group.name?.length) {
      <h5>{{ group.name }}</h5>
    }
    <table>
      <tbody>
        @for (r of group.rows; let rowIdx = $index; track r.apiRow.signature) {
          @if (r.hidden !== true) {
            <tr>
              <td>{{ r.fieldName }}</td>
              <td>
                <kpi4me-cell-editor
                  (cellChanged)="onCellChange($event, groupdIdx)"
                  (updateTable)="onUpdateTable()"
                  (selectionDataChange)="onSelectionDataChange($event)"
                  [params]="r"
                ></kpi4me-cell-editor>
              </td>
              @if (showImports()) {
                <td
                  class="imported-cell"

                >
                  {{ r.imported }}
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  }
}
